// Mount the Warehouse package (#59): build its routes from what it needs from
// this app — the initialised i18n instance (it registers its `warehouse`
// namespace there), the activity feed, and the tour helpers. App.tsx mounts
// the routes from HERE, so the package cannot be mounted unregistered.
// configs/i18n is imported (and so initialised) before the registration runs,
// whatever order main.tsx imports things in. The HTTP clients go through
// core's registry (utils/axios/register-core.ts).
import { lazy, Suspense, type ComponentProps } from 'react'
import { createWarehouseModule } from '@vnetwork/datacentral-warehouse'
import i18n from '@/configs/i18n'
import * as tour from '@/utils/tour-styles'

// Lazy: Activities pulls in the rich-text editor (tiptap). Imported eagerly
// here it would land in the entry chunk (+0.5 MiB, measured); before #59 it
// loaded with the Warehouse route chunk. This keeps it off the entry path.
const LazyActivities = lazy(() => import('@/components/Activities'))
const Activities = (props: ComponentProps<typeof LazyActivities>) => (
    <Suspense fallback={null}>
        <LazyActivities {...props} />
    </Suspense>
)

export const WarehouseModule = createWarehouseModule({ i18n, Activities, tour })
